<template>
  <div class="content">
    <h1 class="content__title">Lista de Productos</h1>
    <span class="content__details">Listado de productos de la página web, administra tambien atributos y otras características.</span>
    <div class="content__container">
      <main class="main">
        <section class="main__section">
          <h2 class="main__title">Lista de Productos</h2>
          <div class="main__results">
            <div class="result" v-if="products === 'loading'">
              <div class="result__data">
                <img class="result__loading" src="/static/img/waiting.gif" alt="Cargando información">
              </div>
            </div>
            <div class="result" v-else-if="!products">
              <div class="result__data">
                <h2 class="result__title">No se encontraron resultados</h2>
              </div>
            </div>
            <div class="result" v-else v-for="(product, index) in products" :key="index">
              <div class="result__data">
                <h2 class="result__title" v-text="'Nombre: ' + product.name_es"></h2>
                <p class="result__detail" v-text="'Grupo: ' + product.group_name_es"></p>
                <p class="result__detail" v-text="'Tipo: ' + product.type_name_es"></p>
              </div>
              <div class="result__options">
                <router-link class="btn btn__default btn--small" :to="{name: 'productEdit', params: {id: product.id}}" > Editar</router-link>
                <button class="btn btn__caution btn--small" @click="deleteProduct(product.id)">Borrar</button>
              </div>
            </div>

          </div>
          <pagination v-if="pagination.pages !== null" :config="pagination"></pagination>
        </section>
      </main>
      <aside class="sidebar">
        <h2 class="sidebar__title">NAVEGACIÓN</h2>
        <router-link class="btn btn--small btn__default" :to="{name: 'productNew'}">Nuevo Producto</router-link>
        <br>
        <h2 class="sidebar__title">CARACTERÍSTICAS</h2>
        <router-link class="btn btn--small btn__default" :to="{name: 'attributeList', params: {page: 1}}">Atributos</router-link>
        <router-link class="btn btn--small btn__default" :to="{name: 'attributeTypeList', params: {page: 1}}">Tipos de Atributo</router-link>
      </aside>
    </div>
    <confirmation v-if="confirm" @cancel="confirm = false"></confirmation>
  </div>
</template>

<script>
import httpService from '@/api/request'
import pagination from '@/components/layout/pagination'
import confirmation from '@/components/layout/confirmation'
export default {
  mixins: [httpService],
  components: {
    pagination,
    confirmation
  },
  data: function () {
    return {
      products: 'loading',
      confirm: false,
      pagination: {
        maxButtons: 8,
        results: null,
        pages: null
      },
      maxResults: 12,
      page: 1,
      id: null
    }
  },
  created: function () {
    this.page = this.$route.params.page
    this.getProducts()
  },
  mounted: function () {
    this.$on('continue', () => {
      this.confirm = false
      this.proccedToDelete()
    })
  },
  watch: {
    '$route.path': function () {
      this.page = this.$route.params.page
      this.getProducts()
    }
  },
  methods: {
    deleteProduct: function (id) {
      this.confirm = true
      this.id = id
    },
    proccedToDelete: function () {
      let httpRequest = {
        module: 'products'
      }
      this.delete(this.id, httpRequest)
        .then(
          () => {
            this.getProducts()
            this.$store.commit('notificate', {
              title: 'PRODUCTO BORRADO',
              text: 'El producto ha sido borrado correctamente.',
              type: 'success'
            })
          }
        )
    },
    getProducts: function (filters = '') {
      let httpRequest = {
        module: 'products',
        params: '?fields=name_es,id,type_name_es,group_name_es&limit=' + this.maxResults + '&page=' + this.page + '&embed=pagination' + filters
      }
      this.get(httpRequest)
        .then(
          products => {
            this.products = products.data
            this.pagination.pages = products.pagination.pages
            this.pagination.currentPage = products.pagination.current_page
            this.pagination.results = products.pagination.results
          }
        )
        .catch(
          () => {
            this.products = null
            this.pagination.pages = null
            this.pagination.currentPage = null
            this.pagination.results = null
            if (this.page > 1) {
              this.$router.push({name: 'productList', params: {page: this.page - 1}})
            }
          }
        )
    },
    getTypes: function () {
      let httpRequest = {
        module: 'attribute_types',
        params: '?fields=name_es,id'
      }
      this.get(httpRequest)
        .then(
          types => {
            this.types = types.data
          }
        )
        .catch(
          () => {
            this.types = []
          }
        )
    },
    filterByType: function (e) {
      let id = e.target.value
      let filters = ''
      if (id && id > 0) {
        filters = '&type_id=eq:' + id
      }
      this.getProducts(filters)
    }
  }
}
</script>


<style lang="sass" scoped>
@import "../../assets/sass/objects/_btns"
</style>



// WEBPACK FOOTER //
// src/components/products/list.vue